import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

type Props = ComponentPropsWithoutRef<'div'> & PropsWithChildren;

const GiftCardNameRow = ({ className, children, ...rest }: Props) => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:GiftCards:GiftCardCategory.product' });

  return (
    <div className={classnames('flex items-center gap-sm', className)} {...rest}>
      <span>{t('name')}</span>
      {children}
    </div>
  );
};

export default GiftCardNameRow;
